import localAxios from '../../localAxios';
import { purgeWorkspaceFoldersURL } from '../workspacesURLs';

interface PurgeWorkspaceFoldersParams {
  workspaceId: string;
  workspaceFolderIds: string[];
}

export async function purgeWorkspaceFolders({
  workspaceId,
  workspaceFolderIds,
}: PurgeWorkspaceFoldersParams) {
  const url = purgeWorkspaceFoldersURL(workspaceId);
  return localAxios.delete(url.href, {
    data: { workspace_folder_ids: workspaceFolderIds },
  });
}
